// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"b2d0f3d1","322":"f9a00fea"}[chunkId] + ".chunk.js";
};